import { filterOptions } from '@/utils/query-base'

const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])
const status = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY'])

/**
 * describe：展示字段是否是描述
 * title：表头字段名称
 *
 * equation：条件
 *
 * type 如果有值将会作为查询条件
 *  -input： 输入框
 *  -select：
 *    dictionary：为字典编码 特殊字典（营销单元(sale)， 基地(base)，省(region)，市(city)，区(street)）
 *  -dialog：
 *    dialog：{
 *      component 弹窗组件 ClientSelect ProductSelect
 *      title 弹窗title
 *    }
 *  -date 时间 格式 年-月-日
 *  -time 时间 格式 时:分:秒
 *  -year 年   格式 年
 *  -whether  是否选项
 */

export const pageSearch = {
  'invoiceNo': {
    title: '制票通知单',
    type: 'input',
    equation: all
  },
  'invoId': {
    title: '发票号',
    type: 'input',
  },
  'billCode': {
    title: '转移单号',
    type: 'input',
    equation: all
  },
  'productDesc': {
    title: '产品选择',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ProductSelect',
      title: '产品选择'
    }
  },
  'transferClient': {
    title: '转出客户编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户选择'
    }
  },
  'receiveClientCode': {
    title: '接收客户编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户选择'
    }
  },
  'createdDate': {
    title: '转移日期',
    type: 'date',
    equation: cusname,
    valueFormat: 'yyyy-MM-dd'
  },
  'planYear': {
    title: '年度',
    type: 'year',
    equation: cusname,
    valueFormat: 'yyyy'
  },
  'billStatus': {
    title: '状态',
    type: 'select',
    dictionary: 'wantgoodStatus',
  }
}

export default {
  'billCode': {
    title: '货权转移单号',
    slot: true
  },
  'invoiceNo': {
    title: '制票通知单'
  },
  'invoId': {
    title: '发票号',
  },
  'transferClient': {
    title: '转出客户'
  },
  'transferName': {
    title: '转出客户名称',
    width: 250
  },
  'receiveClientCode': {
    title: '接收客户'
  },
  'receiveClient': {
    title: '接收客户名称',
    width: 250
  },
  'planTypeTextView': {
    title: '计划类型',
    width: 250
  },
  'planYear': {
    title: '年度'
  },
  'productCode': {
    title: '产品编号'
  },
  'productDesc': {
    title: '产品名称'
  },
  // 'invoiceQuantity': {
  // title: '开票量'
  //  },
  // 'deliveryQuantity': {
  //  title: '发货量'
  // },
  'transferedQuantity': {
    title: '已转移量'
  },
  // 'surplusQty': {
  //  title: '剩余量'
  // },
  'thisTransferQuantity': {
    title: '本次转移量'
  },
  'createdDate': {
    title: '创建日期',
    width: 180
  },
  'approvalCompletedDate': {
    title: '完成日期',
    width: 180
  },
  'billStatusTextView': {
    title: '状态'
  }
}



// WEBPACK FOOTER //
// ./src/views/apply-for-manage/data-searching/config/cargoTransferSearch.js